import React, { useState } from "react";
// import { Link } from "react-router-dom";

import { Monitor, Timer } from "iconsax-react";

import IframeComponent from "../../iframe";

import { StyledSim } from "./styledSim";
import { VideoWrapper } from "../../videoPlayer/styledVideoPlayer";
import { StyledTooltip } from "../../../../style/base/base";
import { memo } from "react";

const SimulatorComponent = ({ simSrc, data }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const handleChangeFullscreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  return (
    <StyledSim className="pt-3 px-4">
      <VideoWrapper $isSim>
        <IframeComponent
          path={simSrc}
          fullScreenInMobile={isFullScreen}
          width="100%"
          height={700}
        />
      </VideoWrapper>
      <footer className="d-flex flex-column-reverse flex-md-row justify-content-center justify-content-md-between  align-items-center py-4">
        <button
          onClick={handleChangeFullscreen}
          className="fullscreen-button bg-transparent"
        >
          نمایش تمام صفحه
        </button>
        <p className="text-center my-4 m-md-0">
          برای یادگیری بیش‌تر شبیه‌ساز، می‌توانید دوباره فیلم راهنما را در تب معرفی
          مشاهده کنید.
          {/* 
              //TODO
              <Link
                to={{ pathname: "./22?tab=info", state: "real_video_path" }}
                className="text-primary text-center d-block d-md-inline mt-2 m-md-0"
              >
                ویدیو راهنما
              </Link> */}
        </p>
        {(data.device === 0 || data.sim_size === 1) && (
          <div className="device-info">
            {data.sim_size === 1 && (
              <StyledTooltip
                title="با توجه به حجم شبیه‌ساز، برای مشاهده آن صبور باشید."
                placement="top-end"
              >
                <>
                  <Timer color="white" size={18} className="icon" />
                </>
              </StyledTooltip>
            )}
            {data.device === 0 && (
              <StyledTooltip
                title="برای مشاهده این شبیه‌ساز از رایانه استفاده کنید."
                placement="bottom-start"
              >
                <>
                  <Monitor color="white" size={18} className="icon" />
                </>
              </StyledTooltip>
            )}
          </div>
        )}
      </footer>
    </StyledSim>
  );
};

export default memo(SimulatorComponent);
